// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1k-2";
export var blackBorderOnHover = "_1k-7";
export var cell = "_1k-6";
export var cellContainer = "_1k-3";
export var checked = "_1k-8";
export var disabled = "_1k-5";
export var featuredIconCellContainer = "_1k-9";
export var featuredIconTextContainer = "_1k-b";
export var featuredIconWrapper = "_1k-a";
export var noBorder = "_1k-c";
export var orangeSelectedRow = "_4k-3";
export var overflowableText = "_1k-0";
export var overflowableTextContainer = "_1k-1";
export var row = "_1j-0";
export var rowCheckboxCell = "_1k-4";
export var selectableTable = "_4k-2";